import { FC } from 'react';
import { BuildInAppToolId, IAppToolProps } from '../../../types/appTools';
import AppTool from './AppTool';
import AppExtension from '../../../../extensions/components/AppExtension';
import EngagementAppEnabled from '../../../toolsEnabled/EngagementAppEnabled';

const SessionExtensionAppTool: FC<IAppToolProps> = ({ selectedApp, extensionId }) => {
    return (
        <EngagementAppEnabled>
            {({ isLoading, isEnabled }) => (
                <AppTool
                    selectedApp={selectedApp}
                    appTool={BuildInAppToolId.SessionExtension}
                    isEnabled={isEnabled}
                    isLoading={isLoading}
                    expandByDefault={true}
                >
                    <AppExtension extensionId={extensionId} />
                </AppTool>
            )}
        </EngagementAppEnabled>
    );
};

export default SessionExtensionAppTool;
